import React from 'react';
import {
    StyledContainerStyle,
    StyledLabelStyle,
    StyledQuantityLabelContainerStyle,
} from './label.style';

const LabelWithAbundance = ({ label, abundance }) => {
    return (
        <div css={StyledContainerStyle}>
            <span css={StyledLabelStyle}>{label}</span>
            {abundance && (
                <span css={StyledQuantityLabelContainerStyle}> {abundance.toLocaleString()}</span>
            )}
        </div>
    );
};

export default LabelWithAbundance;
